import {useSnackbarStore,} from '@/assets/js/src/modules/snackbar/_pinia/snackbar'
import {getActivePinia,} from 'pinia'
import {useRouter,} from 'vue-router'
import {useTranslation} from "@/assets/js/src/util/composables/useTranslation"

export function useShowRegisterMessage () {
    let snackbarStore = useSnackbarStore(getActivePinia())
    let router = useRouter()
    let {t,} = useTranslation()

    return {
        showRegisterMessage: function ({messageKey,placeholder,}) {
            placeholder = placeholder || '{link}'
            let linkId = `id${(new Date()).getUTCMilliseconds()}`
            let partial = `<a href="#" id="${linkId}" title="{{link}}">{{link}}</a>`
            let message = t(messageKey, {link: '{link}',})
                .split(placeholder)
                .join(partial)
                .split('{{link}}')
                .join(t('async.common.button.login_action').toLowerCase())

            snackbarStore.showMessage({
                message,
                type: 'info',
                html: true,
            }).then(()=>{
                let elem = document.getElementById(linkId)
                elem && elem.addEventListener('click', (event) => {
                    event.preventDefault()
                    router.push({path: '/register',}).catch(() => {
                    })
                })
            })
        },
    }
}